// babel-preset-env (which we're using in babel-preset-zocdoc since v5) will automatically
// replace this require with individual polyfills
if (!global._babelPolyfill) {
    require('@babel/polyfill');
}
